import React from 'react';
import styled from 'styled-components';
import media from 'ui/media';
import { KompisSheetHeader } from '@inter-ikea-kompis/react-components';
import { useIntl } from 'react-intl';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

const HeaderWrapper = styled.div`
  ${media.mobile`
    width: 100%;
    padding: 0.5rem 0;
  `}
`;

type Props = {
  backIcon?: boolean;
  heading?: string;
  onBackButtonClick?: () => void;
  onCloseButtonClick?: () => void;
};

const SheetHeader = ({
  backIcon,
  heading,
  onBackButtonClick,
  onCloseButtonClick,
  ...props
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <HeaderWrapper>
      <KompisSheetHeader
        {...props}
        theme={SkapaTheme}
        backIcon={backIcon}
        heading={heading}
        onBackButtonClick={onBackButtonClick}
        onCloseButtonClick={onCloseButtonClick}
        ariaLabelBackButton={formatMessage({ id: 'storageone.backToMenu' })}
        ariaLabelCloseButton={formatMessage({ id: 'storageone.closeButton' })}
      />
    </HeaderWrapper>
  );
};

export default SheetHeader;
